export default __webpack_public_path__ + "static/media/_DSC0146.5df0a851.JPG";